import type { Song } from '~/types/songs';
import songData from '../../data/song-info.json';

export const useSongData = () => {
  return songData as Song[];
};
